import type { FullRecord } from "@shared/types";
import { dSt } from "../util";

interface Props { records: FullRecord[]; }

export function MetricsRow({ records }: Props) {
  const total = records.length;
  const efet = records.filter(d => d.status === "efetivado").length;
  const and_ = records.filter(d => d.status === "analise" || d.status === "cotacao").length;
  const nov = records.filter(d => d.status === "novo").length;
  const conv = total ? Math.round((efet / total) * 100) : 0;
  const urg = records.filter(d => {
    if (!d.prox_data || d.status === "efetivado" || d.status === "perdido") return false;
    const ds = dSt(d.prox_data);
    return ds === "late" || ds === "today";
  }).length;

  return (
    <div className="metrics">
      <div className="metric"><div className="ml">Total</div><div className="mv">{total}</div><div className="ms">prospecções</div></div>
      <div className="metric"><div className="ml">Efetivados</div><div className="mv">{efet}</div><div className="ms">{conv}% de conversão</div></div>
      <div className="metric"><div className="ml">Em andamento</div><div className="mv">{and_}</div><div className="ms">cotação + análise</div></div>
      <div className="metric"><div className="ml">Novos</div><div className="mv">{nov}</div><div className="ms">aguardando ação</div></div>
      <div className={"metric" + (urg > 0 ? " urg" : "")}>
        <div className="ml">Contatos urgentes</div><div className="mv">{urg}</div><div className="ms">hoje ou atrasado</div>
      </div>
    </div>
  );
}
